module.exports = __webpack_public_path__ + "fa-regular-400.7124eb50fc8227c78269.woff";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-regular-400.woff
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-regular-400.woff
// module chunks = styles